import { axiosService, AxiosService } from './axios.service';


/*
 *
 * FAQ Service
 *
 */

class FaqService {

    constructor(private httpService: AxiosService) { }

    public getFaqList() {
        return this.httpService.get('/faq');
    }

}

export default new FaqService(axiosService);
